export default {
      id: "arrow-square-out-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#arrow-square-out",
      toString: function () {
        return this.url;
      }
    }